<template>
  <div class="v-collapse" role="tablist">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide } from 'vue'

import { $collapseKey } from '../../utils/injections.ts'

export type Model = string | number | (string | number)[]

export interface Props {
  arrowRight?: boolean
  headerHeight?: number | string
  lazy?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  arrowRight: false,
  headerHeight: 48,
})

defineSlots<{
  default?(): any
}>()

const model = defineModel<Model>({ default: () => [] })

provide($collapseKey, {
  props,
  model,
})

defineExpose({ model })
</script>

<style>
.v-collapse {
  border-bottom: var(--border);
}
</style>
